// Helpers de migration gRPC → REST (SDK openapi-generator).
// Portés depuis rapsosps-front (front pilote).

import RapsoError from "@/models/RapsoError";

// snake_case → camelCase (clé unique).
export const camelize = (str) =>
  str.replace(/(_[a-z])/g, (match) => match.toUpperCase().replace("_", ""));

// Conversion récursive snake_case → camelCase.
// ⚠️ INUTILE sur les réponses des clients SDK (l'openapi-generator mappe déjà
// snake→camel via `FromJSON`). À réserver aux réponses axios BRUTES (ex. polling
// de statut RG, prévisu) qui renvoient du snake_case non mappé.
export const snakeToCamelDeep = (input) => {
  if (Array.isArray(input)) {
    return input.map(snakeToCamelDeep);
  }
  if (input !== null && typeof input === "object") {
    return Object.fromEntries(
      Object.entries(input).map(([key, value]) => [camelize(key), snakeToCamelDeep(value)]),
    );
  }
  return input;
};

// L.B 12/08/26 clés seulement : `ordering` transporte un nom de champ Django, qui doit
// rester en snake_case. Une conversion profonde le casserait.
export const camelizeKeys = (params) =>
  Object.fromEntries(Object.entries(params ?? {}).map(([key, value]) => [camelize(key), value]));

// L.B 11/08/26 les clients SDK rejettent une ResponseError fetch : `.response` est une
// Response, qui n'a pas de `.data`. RapsoError attend un corps déjà déserialisé, sinon
// il lève un TypeError qui masque l'erreur d'origine.
export const toRapsoError = async (err) => {
  const body = (await err?.response?.json?.().catch(() => ({}))) ?? {};
  return new RapsoError(body, body.code, body.message);
};

export const snakeify = (str) => str.replace(/[A-Z]/g, (match) => `_${match.toLowerCase()}`);

export const camelToSnakeDeep = (input) => {
  if (input instanceof Date) {
    return input;
  }
  if (Array.isArray(input)) {
    return input.map(camelToSnakeDeep);
  }
  if (input !== null && typeof input === "object") {
    return Object.fromEntries(
      Object.entries(input).map(([key, value]) => [snakeify(key), camelToSnakeDeep(value)]),
    );
  }
  return input;
};

// Convertit récursivement les instances Date (produites par les SDK openapi-generator
// qui font `new Date(json[...])`) en chaînes ISO, pour préserver la shape attendue
// par les modèles pinia-orm (le flow gRPC renvoyait des strings).
const ISO_DATE_PREFIX = /^\d{4}-\d{2}-\d{2}(T|$)/;
const isIsoDate = (value) => ISO_DATE_PREFIX.test(value) && !Number.isNaN(Date.parse(value));

// L.B 24/09/26 miroir de serializeDatesDeep : les `ToJSON` du SDK appellent
// `toISOString()` sur les champs date, une chaîne ISO les fait planter.
export const reviveDatesDeep = (input) => {
  if (typeof input === "string") {
    return isIsoDate(input) ? new Date(input) : input;
  }
  if (Array.isArray(input)) {
    return input.map(reviveDatesDeep);
  }
  if (input !== null && typeof input === "object" && !(input instanceof Date)) {
    return Object.fromEntries(
      Object.entries(input).map(([key, value]) => [key, reviveDatesDeep(value)]),
    );
  }
  return input;
};

export const serializeDatesDeep = (input) => {
  if (input instanceof Date) {
    return input.toISOString();
  }
  if (Array.isArray(input)) {
    return input.map(serializeDatesDeep);
  }
  if (input !== null && typeof input === "object") {
    return Object.fromEntries(
      Object.entries(input).map(([key, value]) => [key, serializeDatesDeep(value)]),
    );
  }
  return input;
};
